import router from '@/router'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useSupportModalStore = defineStore('modalStore', () => {
  const openModal = ref<boolean>(false)
  const navTo = ref<string | undefined>()

  // Pymes quotation numbers
  const selectedQuotationNumber = ref<string | null>(null)
  const personalizedQuotationNumber = ref<string | null>(null)
  const needsQuotationNumberReset = ref<boolean>(true)
  const needsPersonalizedQuotationNumberReset = ref<boolean>(true)

  function setOpenModal(value: boolean) {
    openModal.value = value
    if (value === false) {
      resetPymesQuotationNumbers()
      if (navTo.value) {
        router.replace({ name: navTo.value })
        navTo.value = undefined
      }
    }
  }

  function getOpenModal() {
    return openModal.value
  }

  function setNavTo(value: string | undefined) {
    navTo.value = value
  }

  function getNavTo() {
    return navTo.value
  }

  function setSelectedQuotationNumber(value: string | null) {
    selectedQuotationNumber.value = value
  }

  function setPersonalizedQuotationNumber(value: string | null) {
    personalizedQuotationNumber.value = value
  }

  function setNeedsQuotationNumberReset(value: boolean) {
    needsQuotationNumberReset.value = value
  }

  function setNeedsPersonalizedQuotationNumberReset(value: boolean) {
    needsPersonalizedQuotationNumberReset.value = value
  }

  function resetPymesQuotationNumbers() {
    if (needsQuotationNumberReset.value) {
      selectedQuotationNumber.value = null
    }
    if (needsPersonalizedQuotationNumberReset.value) {
      personalizedQuotationNumber.value = null
    }
  }

  return {
    openModal,
    setOpenModal,
    getOpenModal,
    setNavTo,
    getNavTo,
    selectedQuotationNumber,
    personalizedQuotationNumber,
    needsQuotationNumberReset,
    needsPersonalizedQuotationNumberReset,
    setSelectedQuotationNumber,
    setPersonalizedQuotationNumber,
    setNeedsQuotationNumberReset,
    setNeedsPersonalizedQuotationNumberReset,
    resetPymesQuotationNumbers
  }
})
